import { Controller } from '@hotwired/stimulus'
import { handleProductSelectionResponse } from '../selection/response-handler'

/**
 * Handles non-sleeving product selection form submissions (buttons and dropdown)
 * Uses fetch API to submit form and handle JSON responses with HTML fragments
 */
export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', this.handleSubmit.bind(this))
    this.attachButtonHandlers()
  }

  disconnect() {
    this.element.removeEventListener('submit', this.handleSubmit.bind(this))
  }

  attachButtonHandlers() {
    // Handle radio-button-like behavior for picker buttons
    const buttons = this.element.querySelectorAll('.picker-button')
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Store which button was clicked for form submission
        this.clickedButton = e.currentTarget
        
        // Update selected state on all buttons
        buttons.forEach(btn => {
          btn.classList.remove('selected')
          btn.classList.add('unselected')
        })
        e.currentTarget.classList.remove('unselected')
        e.currentTarget.classList.add('selected')
      })
    })
  }

  submit() {
    // Triggered by dropdown change event - submit the form
    this.element.requestSubmit()
  }

  handleSubmit(event) {
    event.preventDefault()
    
    const formData = new FormData(this.element)
    
    // If a button was clicked, include its name/value in the form data
    if (this.clickedButton) {
      const buttonName = this.clickedButton.getAttribute('name')
      const buttonValue = this.clickedButton.value
      if (buttonName && buttonValue) {
        formData.set(buttonName, buttonValue)
      }
    }
    
    const url = this.element.action
    
    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      console.log('Product selection response:', data)
      handleProductSelectionResponse(data)
    })
    .catch(error => {
      console.error('Non-sleeving product selection failed:', error)
    })
  }
}
